import { useAuthUser } from '@/hooks/useAuthUser';
import { useOrganization } from '@/hooks/useOrganization';
import { useServices } from '@/infrastructure/providers/ServiceProvider';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AccountLoadFailed, AuthPending, RedirectToLogin } from './ProtectedRoute';
import { useArrivalReturnPath } from '@/hooks/useArrivalReturnPath';

interface AdminProtectedRouteProps {
  element: React.ReactElement;
}

/** Protects admin-only routes: requires login and subscription plan admin or superuser. */
export const AdminProtectedRoute = ({ element }: AdminProtectedRouteProps) => {
  const { user, loading: authLoading } = useAuthUser();
  const { subscriptionPlan, loading: orgLoading, error: orgError, refresh } = useOrganization();
  const services = useServices();
  const location = useLocation();
  const returnTo = useArrivalReturnPath(!!user);

  const isAdmin =
    subscriptionPlan === 'admin' || services.subscriptionPlan.canOverrideEnvPrefsToViewTemplates(subscriptionPlan || '');

  if (authLoading || orgLoading) return <AuthPending />;
  if (!user) return <RedirectToLogin search={location.search} returnTo={returnTo} />;
  if (!subscriptionPlan && orgError) return <AccountLoadFailed onRetry={() => void refresh()} />;
  if (!isAdmin) return <Navigate to={{ pathname: '/dashboard', search: location.search }} replace />;

  return element;
};
